import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
//import { LANGUAGES } from "constants/supported_lang";
import { PURGE } from "redux-persist";

type agreement = {
  contentTitle: string;
  contentText: string;
  isCompleted: boolean;
};
type thankyou = {
  contentTitle: string;
  contentText: string;
  isCompleted: boolean;
};
type callforward = {
  contentText: string;
  contentRef: string;
};
interface InitialPortalState {
  isAuthenticated: boolean;
  micrositeSession: {
    isAgreed: boolean;
    urlRef: string;
    targetComponent: string;
    landingUrlSnapshot: string;
    pendingSurveys: Array<any>;
  };
  authSession: any;
  authWizard: any;
  uiState: {
    isAppLoading: boolean;
    title: string;
    agreementState: agreement;
    thankyouState: thankyou;
    appointmentCallforwardState: callforward;
    Language: string | "en";
    SurveyLanguage: any;
    LanguageChangedFromDropdown: boolean;
  };
  formData: any;
}
const initialPortalState: InitialPortalState = {
  isAuthenticated: false,
  micrositeSession: {
    urlRef: "",
    isAgreed: false,
    targetComponent: "",
    landingUrlSnapshot: "",
    pendingSurveys: [],
  },
  authSession: {
    auth_progress: "NOT-STARTED",
    is_authenticated: false,
    access_token: "",
    user_name: "",
    user_id: "",
  },
  authWizard: {},
  uiState: {
    isAppLoading: false,
    title: "",
    agreementState: {
      contentTitle: "",
      contentText: "",
      isCompleted: false,
    },
    thankyouState: {
      contentTitle: "",
      contentText: "",
      isCompleted: false,
    },
    appointmentCallforwardState: {
      contentText: "",
      contentRef: "",
    },
    Language: "en",
    SurveyLanguage: 0,
    LanguageChangedFromDropdown: false,
  },
  formData: {},
};
const portalSlice = createSlice({
  name: "portal",
  initialState: initialPortalState,
  reducers: {
    setIsPortalAuthenticated(state, action: PayloadAction<any>) {
      state.isAuthenticated = action.payload;
    },
    setMicrositeSession(state, action: PayloadAction<any>) {
      state.micrositeSession = action.payload;
    },
    updateMicrositeSession(state, action: PayloadAction<any>) {
      let prevmicrositeSessionSession = {
        ...state.micrositeSession,
        ...action.payload,
      };
      state.micrositeSession = prevmicrositeSessionSession;
    },
    updateAuthWizard(state, action: PayloadAction<any>) {
      state.authWizard = action.payload;
    },
    updateAuthWizardStep(state, action: PayloadAction<any>) {
      state.authWizard = action.payload;
    },
    updateAuthSession(state, action: PayloadAction<any>) {
      let prevAuthSession = { ...state.authSession, ...action.payload };
      state.authSession = prevAuthSession;
    },
    updateIsAppLoading(state, action: PayloadAction<any>) {
      let prevUiState = { ...state.uiState, isAppLoading: action.payload };
      state.uiState = prevUiState;
    },
    updateAgreementState(state, action: PayloadAction<any>) {
      console.log("action.payload", action.payload);
      let prevUiState = { ...state.uiState, agreementState: action.payload };
      console.log("prevUiState", prevUiState);
      state.uiState = prevUiState;
    },
    updateThankYouState(state, action: PayloadAction<any>) {
      console.log("action.payload", action.payload);
      let prevUiState = { ...state.uiState, thankyouState: action.payload };
      state.uiState = prevUiState;
    },
    updateAgreementCompleted(state, action: PayloadAction<any>) {
      let prevUiState = { ...state.uiState, isCompleted: action.payload };
      state.uiState = prevUiState;
    },
    updateAgreementStatus(state, action: PayloadAction<any>) {
      let prevMicrositeSession = {
        ...state.micrositeSession,
        isAgreed: action.payload,
      };
      state.micrositeSession = prevMicrositeSession;
    },
    updateConfirmationState(state, action: PayloadAction<any>) {
      let prevUiState = { ...state.uiState, isCompleted: action.payload };
      state.uiState = prevUiState;
    },
    updateLanguageState(state, action: PayloadAction<any>) {
      let prevUiState = { ...state.uiState, Language: action.payload };
      state.uiState = prevUiState;
      state.uiState.LanguageChangedFromDropdown = true;
    },
    resetLanguageChangeFlag(state) {
      state.uiState.LanguageChangedFromDropdown = false;
    },

    updateSurveyLanguageState(state, action: PayloadAction<any>) {
      let prevUiState = { ...state.uiState, SurveyLanguage: action.payload };
      state.uiState = prevUiState;
    },
    updateAppointmentCallforwardState(state, action: PayloadAction<any>) {
      let prevState = {
        ...state.uiState,
        appointmentCallforwardState: action.payload,
      };
      state.uiState = prevState;
    },
    submitFormData(state, action: PayloadAction<any>) {
      state.formData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state.authSession = initialPortalState.authSession;
      state.uiState = initialPortalState.uiState;
      state.micrositeSession = initialPortalState.micrositeSession;
    });
  },
});

export const portalActions = portalSlice.actions;

export default portalSlice;
